import { Component, inject, Signal, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DynamicDialogConfig, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { toSignal } from "@angular/core/rxjs-interop";

import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { AutoCompleteModule } from "@openng/optimus-ui/autocomplete";

import { FaultListService } from "../../../../../services/api/fault-list/fault-list.service";
import { ControllerModel, ControllerModelObject } from "../../../../../models/api/fault/controllerModel";
import { FaultList } from "../../../../../models/api/fault/faultList";
import { first } from "rxjs";
import { SelectModule } from "@openng/optimus-ui/select";
import { TextareaModule } from "@openng/optimus-ui/textarea";

@Component({
  standalone: true,
  selector: "app-model",
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    TranslateModule,
    InputTextModule,
    AutoCompleteModule,
    SelectModule,
    TextareaModule,
  ],
  templateUrl: "./model.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./model.component.scss",
})
export class ModelComponent {
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef);

  public translate = inject(TranslateService);
  private faultListService = inject(FaultListService);

  private model: ControllerModel = new ControllerModel(this.config.data.controllerCatalogItem);
  public form = new FormGroup({
    label: new FormControl(this.model.label, Validators.required),
    faultList: new FormControl(this.model.faultList?.id, Validators.required),
    notes: new FormControl(this.model.notes),
  });

  public faultLists: Signal<FaultList[]> = toSignal(this.faultListService.getFaultLists().pipe(first()), {
    initialValue: [],
  });

  /**
   * Closes the dialog with the updated model if the form is valid.
   * @param modelValues The values of the form controls.
   * @returns The updated model.
   */
  public save() {
    const modelValues = this.form?.value;
    if (this.form.valid && modelValues.faultList && modelValues.label) {
      const model: ControllerModelObject = {
        manufacturer: this.model.manufacturer,
        label: modelValues.label,
        faultList: { id: modelValues.faultList },
        notes: modelValues.notes,
      };
      this.model.properties = model;
      this.ref.close(this.model);
    }
  }

  /**
   * Closes the dialog without returning any data.
   */
  public closeDialog() {
    this.ref.close();
  }
}
